const activeId = (state = '0', { type, id }) => {
  switch (type) {
    case 'ACTIVE_ID':
      return id

    default:
      return state
  }
}

export default activeId